import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(requireLoggedIn);

import { select, call } from 'redux-saga/effects';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { isLoggedIn as stateIsLoggedIn } from 'redux/modules/user';
import { isLoggedIn as sagaSelectorIsLoggedIn } from 'redux/saga/selectors';
export var isLoggedIn = function isLoggedIn(store) {
  return new Promise(function (resolve) {
    return resolve(stateIsLoggedIn(store.getState()));
  });
};
export default function requireLoggedIn(nextState, replaceState, forceTo) {
  return regeneratorRuntime.wrap(function requireLoggedIn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(sagaSelectorIsLoggedIn);

        case 2:
          if (_context.sent) {
            _context.next = 6;
            break;
          }

          _context.next = 5;
          return call(replaceState, forceTo || loginRedirectUrl(nextState.location));

        case 5:
          return _context.abrupt("return", _context.sent);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}